module.exports = __webpack_public_path__ + "static/media/accutrainee-logo.8a14ae38.svg";